import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import Filters from "../components/RawData/Filters";
import LogsTable from "../components/RawData/LogsTable";
import Pagination from "../components/RawData/Pagination";
import ErrorBox from "../components/RawData/ErrorBox";

const MAX_MINUTES = 24 * 60; // 24 giờ

export default function RawData() {
  const [health, setHealth] = useState("Đang kiểm tra...");
  const [filters, setFilters] = useState({
    imei: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [totalRecords, setTotalRecords] = useState(0); // Thêm state để lưu tổng số bản ghi

  // LOGIC PHÂN TRANG FRONTEND: Tính toán dữ liệu hiển thị cho trang hiện tại
  const indexOfLastRecord = page * pageSize;
  const indexOfFirstRecord = indexOfLastRecord - pageSize;
  const currentLogs = logs.slice(indexOfFirstRecord, indexOfLastRecord);

  // Cập nhật totalRecords mỗi khi logs thay đổi
  useEffect(() => {
    setTotalRecords(logs.length);
  }, [logs]);

  const buildPayload = () => {
    setErrorMsg("");
    const { imei, startDate, startTime, endDate, endTime } = filters;

    if (!imei) {
      setErrorMsg("Vui lòng nhập IMEI.");
      return null;
    }

    if (!startDate || !startTime || !endDate || !endTime) {
      setErrorMsg("Vui lòng chọn đầy đủ ngày và giờ.");
      return null;
    }

    const start = new Date(`${startDate}T${startTime}:00`);
    const end = new Date(`${endDate}T${endTime}:00`);
    const diffMinutes = (end - start) / 60000;

    if (diffMinutes <= 0 || diffMinutes > MAX_MINUTES) {
      setErrorMsg("Khoảng thời gian không hợp lệ (0 < t <= 24h).");
      return null;
    }

    return {
      imei,
      start_time: start.toISOString(),
      end_time: end.toISOString(),
      // BỎ page và page_size ở đây vì phân trang ở frontend
    };
  };

  const fetchLogs = async () => {
    const payload = buildPayload();
    if (!payload) return;

    try {
      setLoading(true);
      setPage(1); // Reset về trang 1 khi tìm kiếm mới
      const res = await axios.post("/logs/raw-data", payload);
      const data = res.data || [];
      console.log('data',data)
      setLogs(data);
    } catch (err) {
      setErrorMsg(err.response?.data?.detail || "Lỗi khi gọi API");
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  // XÓA useEffect cũ gọi fetchLogs khi thay đổi page/pageSize
  // Chỉ gọi fetchLogs khi người dùng nhấn nút "Tìm kiếm" (thông qua onSubmit của Filters)

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 px-6 py-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6 border-b pb-4">
        <div>
          <h1 className="text-2xl font-semibold">Tra cứu lịch sử</h1>
          <p className="text-sm text-gray-600">Theo IMEI và khoảng thời gian</p>
        </div>
        <span className="text-sm px-3 py-1 rounded-full border">{health}</span>
      </div>

      <Filters
        filters={filters}
        setFilters={setFilters}
        pageSize={pageSize}
        setPageSize={(val) => {
          setPageSize(val);
          setPage(1); // Reset về trang 1 khi đổi số bản ghi/trang
        }}
        onSubmit={fetchLogs} // Gọi trực tiếp fetchLogs
        loading={loading}
      />

      {errorMsg && <ErrorBox message={errorMsg} />}

      <LogsTable logs={currentLogs} loading={loading} />

      <Pagination
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        totalRecords={totalRecords}
        loading={loading}
      />
    </div>
  );
}
